import { PayloadJWT, PerfilDeOrganizacao } from "@/types/gerais"

export function usarPayloadJWT() {
  const parseJwt = (token: string): PayloadJWT | undefined => {
    if (!token) {
      return
    }
    const base64Url = token.split(".")[1]
    const base64 = base64Url.replace("-", "+").replace("_", "/")
    return JSON.parse(window.atob(base64))
  }

  const obterPerfilDeOrganizacao = (token: string): PerfilDeOrganizacao => {
    const payload = parseJwt(token)
    return payload ? payload.perfil_de_organizacao : "pessoal"
  }

  const obterIdDoCliente = (token: string): string => {
    const payload = parseJwt(token)
    return payload ? payload.cliente_id : ""
  }

  const obterIdDoUsuarioLogado = (token: string): string => {
    const payload = parseJwt(token)
    return payload ? payload.sub : ""
  }

  return {
    parseJwt,
    obterPerfilDeOrganizacao,
    obterIdDoCliente,
    obterIdDoUsuarioLogado,
  }
}
